import React from 'react';
import SearchBar from '~/components/SearchBar';
import Sub2 from './Sub2';
import PierItem_FoundationPile from './PierItem_FoundationPile';

const App = props => {
  const { disabled, data, changeData, checkSubChange } = props;
  return (
    <SearchBar style={{ marginTop: 8 }} text='零組件存放碼頭' defaultOpen>
      {/* <Sub2 {...props} /> */}
      <PierItem_FoundationPile title='基樁存放' disabled={disabled} data={data.sub4 || []} onChange={data => changeData({ label: 'sub4', data })} />
      <PierItem_FoundationPile title='套筒/TP存放' disabled={disabled} data={data.sub5 || []} onChange={data => changeData({ label: 'sub5', data })} />
      <PierItem_FoundationPile title='塔架存放' disabled={disabled} data={data.sub6 || []} onChange={data => changeData({ label: 'sub6', data })} />
      <PierItem_FoundationPile title='機艙存放' disabled={disabled} data={data.sub7 || []} onChange={data => changeData({ label: 'sub7', data })} />
      <PierItem_FoundationPile title='葉片存放' disabled={disabled} data={data.sub8 || []} onChange={data => changeData({ label: 'sub8', data })} />
    </SearchBar>
  );
};

export default App;
